import { BehaviorSubject } from 'rxjs';
import { CgpIdleService } from './../../cgp-idle/cgp-idle.service';
// File: cgp-app-bar-menu-component.ts
// Author: James L Seebach
// Date: 5/12/2017
// Desc: CGP App Bar Menu component.
// Other Contributors: Joseph M Diaz

import { Component } from '@angular/core';

import { CgpUserProfileDialogService } from '../../cgp-user-profile-dialog/cgp-user-profile-dialog.service';
import { cgpAuthentication } from '../../../../modules/cgp-authentication';
import { config } from "../../../../config/config";

import * as moment from 'moment';

@Component({
   selector: 'cgp-app-bar-user-menu',
   templateUrl: './cgp-app-bar-user-menu.template.html'
})
export class CgpAppBarUserMenuComponent {
   user;
   userMenuText;
   userMenuItems;

   remainingTime: number;

   constructor(
      private readonly cgpUserProfileDialogService: CgpUserProfileDialogService,
      private readonly idle: CgpIdleService
   ) {
      this.user = cgpAuthentication.getUserInfo();
      this.userMenuItems = this.getUserMenuItems();
      this.userMenuText = moment(new Date()).format('MM/DD/YYYY');

      setInterval(
         () => this.remainingTime = Math.max(Math.ceil((this.idle.getLogoutTime().getTime() - Date.now()) / 60000), 0),
         1000
      );
   }

   getUserMenuItems = () => {
      const results = config.appBarUserMenu.items.map((item: any) => {
         item.showIcon = (item.icon) ? true : false;
         return item;
      });

      return results;
   }

   get userName() {
      let name = '';
      if (!this.user) { return name; }

      // Deprecated way of retrieving user full name but
      // we place a check just in case it is being
      // used
      if (this.user.cn) {
         name = this.user.cn;
      } else if (this.user.firstName && this.user.lastName) {
         name = `${this.user.firstName} ${this.user.lastName}`;
      }

      return name;
   }

   onItemClick = (item) => {
      switch (item.action) {
         case "openProfileDialog":
            this.onShowUserProfileClick();
            break;
         case "logOut":
            window.location.href = "#/logged-out";
            break;
      };
   }

   onShowUserProfileClick = () => {
      this.cgpUserProfileDialogService.showUserProfileDialog({
         title: "User Profile",
         closeLabel: "Ok"
      });
   }
}